import { Module } from 'vuex';

import { RootStateI } from '../state';
import { state, AppointmentState } from './state';
import actions from './actions';
import mutations from './mutations';

const module: Module<AppointmentState, RootStateI> = {
  state,
  actions,
  mutations,
  namespaced: true,
};

export default module;
